import { render, staticRenderFns } from "./DecoradoIntro.vue?vue&type=template&id=6de0eb12&scoped=true&"
import script from "./DecoradoIntro.vue?vue&type=script&lang=js&"
export * from "./DecoradoIntro.vue?vue&type=script&lang=js&"
import style0 from "./DecoradoIntro.vue?vue&type=style&index=0&id=6de0eb12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de0eb12",
  null
  
)

export default component.exports